import { Coffee, TrendingUp } from "lucide-react";
import { renderDuration } from "../helpers/eventdisplay/renderDuration";
import { cn } from "../../../../lib/utils";

interface BreakOvertimeIndicatorProps {
    breakDuration: number;
    overtimeDuration: number;
    size?: number;
}

function BreakOvertimeIndicator({ breakDuration, overtimeDuration, size = 16 }: BreakOvertimeIndicatorProps) {
    const textSize = size >= 17 ? "tw-text-sm" : "tw-text-xs";

    if (overtimeDuration <= 0 && breakDuration <= 0) return null;

    return (
        <div className="tw-flex tw-flex-col tw-items-end">
            {overtimeDuration > 0 && (
                <div className={cn("tw-flex tw-items-center", textSize, "tw-gap-1 tw-text-rose-900")}>
                    <TrendingUp size={size} />
                    {renderDuration(overtimeDuration)}
                </div>
            )}
            {breakDuration > 0 && (
                <div className={cn("tw-flex tw-items-center", textSize, "tw-text-primary tw-gap-1")}>
                    <Coffee size={size} className="tw-text-primary tw-mb-1" />
                    {renderDuration(breakDuration)}
                </div>
            )}
        </div>
    );
}

export default BreakOvertimeIndicator;
